import { useEffect } from "react";
import { useSuccess } from "../contexts/SuccessContext.tsx";

const SuccessToast = () => {
  const { messages, removeSuccess, topSuccess, setSuccess } = useSuccess();

  useEffect(() => {
    if (messages.length > 0) {
      const timers = messages.map((_, idx) =>
        setTimeout(() => removeSuccess(idx), 2000 + idx * 100)
      );
      return () => timers.forEach(clearTimeout);
    }
  }, [messages, removeSuccess]);

  // Auto-remove top notification
  useEffect(() => {
    if (topSuccess) {
      const timer = setTimeout(() => setSuccess(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [topSuccess, setSuccess]);

  if (messages.length === 0) return null;

  return (
    <>
      {/* Top center notification */}
      {topSuccess && (
        <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50 bg-green-600 text-white px-6 py-3 rounded shadow-lg flex items-center">
          <span>{topSuccess}</span>
          <button className="ml-6 underline" onClick={() => setSuccess(null)}>
            Kapat
          </button>
        </div>
      )}
      {/* Bottom right stacked toasts */}
      {messages.length > 0 && (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
          {messages.map((msg, idx) => (
            <div
              key={idx}
              className="bg-green-600 text-white px-6 py-3 rounded shadow-lg flex items-center min-w-[200px]"
            >
              <span>{msg}</span>
              <button className="ml-6 underline" onClick={() => removeSuccess(idx)}>
                Kapat
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default SuccessToast;